/**
 * 番号付きのテキストにして返す
 * @param mainText 表示するテキスト
 * @param number 表示する番号
 * @param attachmentText 番号前につけるテキスト
 * @returns
 */
export const getLabelWithOrder = (mainText, number, attachmentText) => {
    const numberText = number !== null && number !== void 0 ? number : '';
    return numberText !== ''
        ? `${attachmentText || ''}${numberText}. ${mainText}`
        : mainText;
};
